// useCountUp — animate a number from 0 to target on mount/change.
// Returns the current frame value (rounded to `decimals`).
import { useEffect, useState, useRef } from 'react';

export default function useCountUp(target, { duration = 700, decimals = 0 } = {}) {
  const [value, setValue] = useState(0);
  const frame = useRef();
  const startTs = useRef();
  const startVal = useRef(0);

  useEffect(() => {
    if (target == null || isNaN(target)) { setValue(0); return; }
    cancelAnimationFrame(frame.current);
    startTs.current = null;
    startVal.current = value;
    const tick = (ts) => {
      if (!startTs.current) startTs.current = ts;
      const t = Math.min(1, (ts - startTs.current) / duration);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - t, 3);
      const v = startVal.current + (target - startVal.current) * eased;
      const f = Math.pow(10, decimals);
      setValue(Math.round(v * f) / f);
      if (t < 1) frame.current = requestAnimationFrame(tick);
    };
    frame.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);

  return value;
}
